import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/app/commons/shared.module.ts' );
import {Injectable, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { Vasat} from 'vasat';
import { VasatModule } from 'vasat-ng'
import {AppDialog} from './dialogs/app-dialog';
import {DZIDialog, MapDialog} from './dialogs/map-dialog';
import {VasatQMAPService} from './app.service'
import {AppRoutes} from './global'
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatPaginatorModule} from '@angular/material/paginator';
import {ExplorerListComponent} from './explorer-list.component';
import {ExplorerTreeComponent} from './explorer-tree.component';
import {CtxMenuTrigger} from './ctx-menu';
import {DegPipe, FormatFileSizePipe, LocalizedDatePipe, PercentPipe, RoundPipe} from './date-pipe'
import {MatBadgeModule} from '@angular/material/badge'
import {MatExpansionModule} from '@angular/material/expansion';
import {DateAgoPipe} from '../pipes/date-ago.pipe';
import { NormaliseAclPipe } from '../pipes/normalise-acl.pipe';
import { TranslateDbPipe } from '../pipes/translate-db.pipe';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialog,
  MatDialogModule,
  MatDividerModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatIconRegistry,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSidenavModule, MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatTreeModule
} from '@angular/material';


import {Dataset, Folder, Transform, FourDService} from '4d-mapper'

import {NotFoundComponent} from '../root.component';
import {QMAPModule, QMAPService} from 'ng-qmap';
import {AnnotationReportComponent} from '../main/map/annotation-report';
import {MapDialogPlotAll} from './dialogs/map-dialog-plot-all';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {APIDialog, EmptyDialog} from './dialogs/explorer.dialogs';
import {ExplorerComponent} from '../main/explorer/explorer.component';

import {ScrollingModule} from '@angular/cdk/scrolling';
import {EpsgcodeDialog} from './dialogs/epsgcode/epsgcode-dialog.component';
import { UploadGlobalComponent } from './dialogs/upload-global/upload-global.component';
import { HangOnComponent } from './dialogs/hang-on/hang-on.component';
import {UploadToProjectComponent} from './dialogs/upload-to-project/upload-to-project.component';
import { ResizableModule } from 'angular-resizable-element';
import { SetupDialog } from './dialogs/setup-dialog';

import { NgSelectModule } from '@ng-select/ng-select';
import { Ng2SlideDownModule } from 'ng2-slide-down';
import { AlignBoundsComponent, AlignBoundsDialog } from './dialogs/align-bounds/align-bounds.component';
import { NavToolbarComponent } from '../main/map/nav-toolbar/nav-toolbar.component';

import { ZoomableCanvasComponent } from '@durwella/zoomable-canvas';
import { EditorDialog } from './plugins/editor-handler';
import { ConfigDialog } from './plugins/visual-controller';
import { PluginUiComponent } from './plugins/plugin-ui/plugin-ui.component';
import { PluginUiSectionComponent } from './plugins/plugin-ui-section/plugin-ui-section.component';
import { SharableComponent } from '../main/sharable/sharable.component';

import { QuickGuidesComponent } from './../main/map/quick-guides/quick-guides.component';
import { EditWorkflowComponent } from './ui/edit-workflow/edit-workflow.component';

import { PropertyViewerComponent } from './ui/property-viewer/property-viewer.component';
import { PanelComponent } from './ui/workflow/panel/panel.component';
import { TaskbarComponent } from '../main/map/taskbar/taskbar.component';
import { ItemsComponent } from './ui/workflow/items/items.component';
import { ListItemsComponent } from './ui/list-items/list-items.component';
import { BucketsComponent } from './ui/buckets/buckets.component';
import { BucketComponent } from './ui/buckets/bucket/bucket.component';

import { MapViewerComponent } from './mapViewer.component';
import { XsIdentityInterface } from '../xs/interfaces/identify.interface';

import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/pro-solid-svg-icons';
import {far} from '@fortawesome/pro-regular-svg-icons';
import {fal} from '@fortawesome/pro-light-svg-icons';
import {fab} from '@fortawesome/free-brands-svg-icons';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ColormapDialog } from './plugins/colorizing-handler';
import { FdmDynamicMenuComponent } from './ui/dynamic-menu/dynamic-menu.component';
import { NotificationDialog } from './dialogs/notification-dialog';
import { SceneFilterPipe } from '../pipes/scene-filter.pipe';
import { MapDataService } from '../v2/commons/map-data.service';
import { UploadWMSComponent } from './dialogs/upload-wms/upload-wms.component';
import { FdmFilesModule } from '../v2/commons/files/files.module';
import { TreeNodeBuilder } from '../v2/commons/files/tree-events';
import { EmbedCodeDialog } from './dialogs/embed-code-dialog';
library.add(fas, far, fal, fab);

@NgModule({
  imports: [
    QMAPModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatCardModule,
    FontAwesomeModule,
    MatToolbarModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule, MatExpansionModule,
    MatInputModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatRadioModule,
    MatTabsModule,
    MatTableModule,
    CommonModule,
    MatDialogModule, MatPaginatorModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatDividerModule,
    MatGridListModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatSidenavModule,
    MatListModule,
    MatStepperModule,
    MatSortModule,
    MatBadgeModule,
    MatChipsModule,
    TranslateModule,
    MatTreeModule,
    DragDropModule,
    MatSliderModule,
    MatCheckboxModule,
    ScrollingModule,
    VasatModule,
    ResizableModule,
    NgSelectModule,
    ColorPickerModule,
    Ng2SlideDownModule,
    NgxChartsModule,
    NgxSliderModule,
    FdmFilesModule
  ],
  declarations: [
    LocalizedDatePipe,
    FormatFileSizePipe,
    PercentPipe, ExplorerListComponent, ExplorerTreeComponent, RoundPipe, DegPipe,
    AppDialog, MapDialog, MapDialogPlotAll, DZIDialog, SetupDialog, EditorDialog, ConfigDialog, ColormapDialog, NotificationDialog, EmbedCodeDialog,
    AnnotationReportComponent,

    MapViewerComponent,

    NotFoundComponent,
    CtxMenuTrigger,
    APIDialog, EmptyDialog,
    ExplorerComponent, EpsgcodeDialog,
    DateAgoPipe,
    NormaliseAclPipe,
    SceneFilterPipe,
    TranslateDbPipe,
    UploadGlobalComponent,
    UploadWMSComponent,
    UploadToProjectComponent,
    HangOnComponent, NavToolbarComponent,
    AlignBoundsComponent,AlignBoundsDialog,
    ZoomableCanvasComponent,
    PluginUiComponent,
    PluginUiSectionComponent,
    SharableComponent,
    QuickGuidesComponent,
    EditWorkflowComponent,
    TaskbarComponent,
    PropertyViewerComponent,
    PanelComponent,
    ItemsComponent,
    ListItemsComponent,
    BucketsComponent,
    BucketComponent,

    FdmDynamicMenuComponent,
  ],
  exports: [
    QMAPModule,
    LocalizedDatePipe, PercentPipe, ExplorerListComponent, ExplorerTreeComponent, CtxMenuTrigger, RoundPipe, DegPipe,
    FormatFileSizePipe,
    MatTooltipModule,
    MatProgressBarModule, MatExpansionModule,
    MatCardModule,
    MatToolbarModule,
    APIDialog, EmptyDialog,
    EpsgcodeDialog,
    MatAutocompleteModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTabsModule,
    MatSnackBarModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatDividerModule,
    MatGridListModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatBadgeModule,
    MatChipsModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatListModule,
    MatStepperModule,
    MatRadioModule,
    MatCheckboxModule,
    MatTreeModule,
    MatSortModule,
    CommonModule,
    FontAwesomeModule,
    MatTableModule,
    TranslateModule,
    MapViewerComponent,
    NotFoundComponent,
    DragDropModule,
    ExplorerComponent,
    MatSliderModule,
    ScrollingModule,
    VasatModule,
    DateAgoPipe,
    NormaliseAclPipe,
    SceneFilterPipe,
    TranslateDbPipe,
    UploadGlobalComponent,
    UploadWMSComponent,
    HangOnComponent, NavToolbarComponent,
    ResizableModule,
    NgSelectModule,
    ColorPickerModule,
    Ng2SlideDownModule,
    AlignBoundsDialog,
    AlignBoundsComponent,
    PluginUiComponent,
    PluginUiSectionComponent,
    SharableComponent,
    QuickGuidesComponent,
    EditWorkflowComponent,
    TaskbarComponent,
    PropertyViewerComponent,
    PanelComponent,
    ListItemsComponent,
    BucketsComponent,
    BucketComponent,
    NgxChartsModule,
    NgxSliderModule,
    FdmDynamicMenuComponent,
    FdmFilesModule
  ],
  providers: [
    MatIconRegistry,
    MapDataService,
    TreeNodeBuilder,
    {
      provide: QMAPService,
      useClass: VasatQMAPService
    }
  ],
  entryComponents: [
    AppDialog,
    MapDialog,
    MapDialogPlotAll,
    DZIDialog,
    SetupDialog,
    NotificationDialog,
    AnnotationReportComponent, APIDialog, EmptyDialog, EpsgcodeDialog, UploadGlobalComponent, UploadToProjectComponent, UploadWMSComponent,
    AlignBoundsDialog, EditorDialog, ConfigDialog, ColormapDialog, SharableComponent,
    EmbedCodeDialog
  ]
})
export class SharedModule implements XsIdentityInterface {

  __ID = XsIdentityInterface.__init(this);

}

@Injectable()
export class LoginNeeded implements CanActivate {
  constructor(protected V: Vasat, protected r: Router) {
    DEBUG.log ( '/app/commons/shared.module.ts', 'LoginNeeded CONSTRUCTOR' );
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.V.localSession()) {
      return true
    } else {
      this.r.navigate([AppRoutes.AUTH], {queryParams: {prevpage: state.url, msg: 'Login Timed out'}})
      return false
    }
  }
}

@Injectable()
export class AccountNeeded extends LoginNeeded {
  constructor(private fourD: FourDService, r: Router) {
    super(fourD.V, r);
    DEBUG.log ( '/app/commons/shared.module.ts', 'AccountNeeded CONSTRUCTOR' );
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!super.canActivate(route, state)) {
      return false
    }
    if (!this.fourD.teams || !this.fourD.teams.length) {
      this.fourD.onReady().subscribe(s => {
        if (!this.fourD.teams.find(t => t.active)) {
          this.r.navigate(['/app/admin/plan'])
        }
      })
      // still loading
      return true
    }
    else if (this.fourD.teams.find(t => t.active)) {
      return true
    } else {
      this.r.navigate(['/app/admin/plan'])
      return false
    }
  }
}


/*export class BaseComponent {

  loading: boolean = false
  routes = AppRoutes
  appConstants = AppConstants

  snotifyService: SnotifyService = AppModule.injector.get(SnotifyService)
  translate: TranslateService = AppModule.injector.get(TranslateService)

  constructor(public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog) {
    //this.snotifyService = AppModule.injector.get(SnotifyService)
  }

  private openSnackBar(message: string, action: string = '', type?: string, meta?: any) {
    if (message == null) message = ''
    if (action == null) action = ''
    this.translate.get([message, action, 'DIALOG.SUCCESS', 'DIALOG.INFO', 'DIALOG.WARNING', 'DIALOG.ERROR'], meta)
      .subscribe(param => {
        let successTitle = param['DIALOG.SUCCESS']
        let infoTitle = param['DIALOG.INFO']
        let warningTitle = param['DIALOG.WARNING']
        let errorTitle = param['DIALOG.ERROR']
        if (message) message = param[message]
        if (action) action = param[action]

        if (this.isMobile()) {
          return this.snackBar.open(message, action, {
            SNACKBAR_DURATION: 5000,
            panelClass: type ? type : ''
          })
        } else if (action) {
          this.snotifyService.confirm(message, {
            showProgressBar: false,
            closeOnClick: false,
            type: this.getSnotifyType(type),
            buttons: [
              {
                text: action, action: (toast) => {
                  this.snotifyService.remove(toast.id);
                }, bold: true
              }
            ]
          })
        } else if (type == Notification.INFO) {
          this.snotifyService.info(message, infoTitle)
        } else if (type == Notification.SUCCESS) {
          this.snotifyService.success(message, successTitle)
        } else if (type == Notification.WARN) {
          this.snotifyService.warning(message, warningTitle)
        } else if (type == Notification.ERROR) {
          this.snotifyService.error(message, errorTitle)
        } else {
          this.snotifyService.simple(message)
        }

      })

  }

  getSnotifyType(type: string): SnotifyType {
    if (type == Notification.INFO) return 'info'
    else if (type == Notification.SUCCESS) return 'success'
    else if (type == Notification.ERROR) return 'error'
    else if (type == Notification.WARN) return 'warning'
    else return 'simple'
  }

  openSnackBarInfo(message: string, action?: string, meta?: any) {
    return this.openSnackBar(message, action, Notification.INFO, meta)
  }

  openSnackBarSuccess(message: string, action?: string, meta?: any) {
    return this.openSnackBar(message, action, Notification.SUCCESS, meta)
  }

  openSnackBarError(message: string, action?: string, meta?: any) {
    return this.openSnackBar(message, action, Notification.ERROR, meta)
  }

  openSnackBarWarn(message: string, action?: string, meta?: any) {
    return this.openSnackBar(message, action, Notification.WARN, meta)
  }

  openDialog(title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any, error?: { status, message }): Observable<any> {

    let dialogRef = this.dialog.open(AppDialog, {
      width: '350px',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, error: error}
    });

    return dialogRef.afterClosed()
  }

  openMapDialogWithItems(ds: Dataset, items: Transform[], title: string, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {

    let dialogRef = this.dialog.open(MapDialog, {
      width: '80%',
      height: '80%',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, items: items, dataset: ds}
    });

    return dialogRef.afterClosed()
  }

  openMapDialogPlotAllWithItems(ds: Dataset, items: Transform[], title: string, selectedFolder?: Folder, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {

    let dialogRef = this.dialog.open(MapDialogPlotAll, {
      width: '80%',
      height: '80%',
      data: {
        title: title,
        text: desc,
        posBtn: posBtn,
        negBtn: negBtn,
        items: items,
        dataset: ds,
        selectedFolder: selectedFolder
      }
    });

    return dialogRef.afterClosed()
  }

  openDZIDialogWith(img: Transform, title: string, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {

    let dialogRef = this.dialog.open(DZIDialog, {
      width: '65%',
      height: '80%',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, img: img}
    });

    return dialogRef.afterClosed()
  }

  /!*openMetadataDialogWith(title: string, desc?: string, posBtn?: string, negBtn?: string): Observable<any> {

    let dialogRef = this.dialog.open(MetadataDialogComponent, {
      width: '65%',
      height: '80%',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn}
    });

    return dialogRef.afterClosed()
  }*!/


  openDialogWithMode(mode: string, title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any, error?: { status, message }, width?: string): Observable<any> {

    let dialogRef = this.dialog.open(AppDialog, {
      width: width ? width : '80%',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, error: error, mode: mode}
    });

    return dialogRef.afterClosed()
  }

  openDialogWithModeAndFilter(mode: string, filter: any, title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any, error?: { status, message }): Observable<any> {

    let dialogRef = this.dialog.open(AppDialog, {
      width: '80%',
      data: {
        title: title,
        text: desc,
        posBtn: posBtn,
        negBtn: negBtn,
        input: input,
        error: error,
        mode: mode,
        filter: filter
      }
    });

    return dialogRef.afterClosed()
  }

  openDialogWithModeAndFilterAndMeta(meta: any, mode: string, filter: any, title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any, error?: { status, message }): Observable<any> {

    let dialogRef = this.dialog.open(AppDialog, {
      width: '80%',
      data: {
        meta: meta,
        title: title,
        text: desc,
        posBtn: posBtn,
        negBtn: negBtn,
        input: input,
        error: error,
        mode: mode,
        filter: filter
      }
    });

    return dialogRef.afterClosed()
  }

  openDialogWithMeta(meta: any, title: string, desc?: string, posBtn?: string, negBtn?: string, input?: any, error?: { status, message }): Observable<any> {

    let dialogRef = this.dialog.open(AppDialog, {
      width: '350px',
      data: {title: title, text: desc, posBtn: posBtn, negBtn: negBtn, input: input, error: error, meta: meta}
    });

    return dialogRef.afterClosed()
  }

  replace(value: string, params: Array<string>): string {
    params.forEach((element, index) => {
      value = value.replace('$%' + (index + 1), element)
    });
    return value
  }

  navigateToRoute(route: string) {
    this.router.navigateByUrl(route)
  }

  goBack() {
    window.history.back()
  }

  /!**
   * Returns true if the screen is mobile size
   *!/
  isMobile() {
    return window.innerWidth <= AppConstants.SCREEN_MOBILE
  }
}

export class AppBaseComponent extends BaseComponent {

  sub: Subscription

  //activeUser:User

  constructor(protected service: AppService, public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog) {
    super(router, snackBar, dialog)
  }

  ngOnInit() {
    if (this.service.V.localSession()) {
      this.service.onReady().subscribe(
        s => {
          this.onReady()
        },
        e => {
          if (e instanceof VasatError) {
            // TODO
          }
          this.onError()
        })
    } else {
      this.router.navigateByUrl(this.routes.AUTH + '?prevpage=' + this.router.routerState.snapshot.url)
    }
  }

  onReady() {

  }

  onError() {

  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe()
  }

  setProp<T extends VasatModel<T>>(model: T, propName: string, value?: boolean) {
    //console.log("ENTER prop: " + propName + " value: " + value)
    //console.log(JSON.stringify(model.props))
    // Initialize props if undefinned
    if (!model.props) model.props = {}
    model.props[propName] = value
    //console.log(JSON.stringify(model.props))
    this.loading = true
    model.saveObservable().subscribe(
      res => {
        this.loading = false
      },
      err => {
        this.loading = false
        this.openSnackBarError(err.status + ' ' + err.message)
      }
    )
  }

}*/

export interface FileStub {
  valid: boolean
  file?: File
  dataset?: Dataset
}

